import styles from "../../../styles/intro.module.css";
import introimage from "../../../images/intro-image.png";

const Intro = () => {
  return (
    <div className={styles.introwrapper}>
      <img className={styles.introimage} src={introimage} alt="" />
      <div className={styles.intro}>
        <div className={styles.introtextwrapper}>
          <h1 className={styles.introtext}>WELCOME TO</h1>
          <h1 className={styles.introtext}>I.G.S</h1>
        </div>
        <p className={styles.introquote}>
          Let us think of education as the means of developing our greatest
          abilities, because in each of us there is a private hope and dream
          which fulfilled can be translated into benefit for everyone and
          greater strenght for our nation. (John F.Kennedy)
        </p>
        <button className={styles.largebtn}>TAKE A TOUR</button>
      </div>
    </div>
  );
};

export default Intro;
